var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar2Black(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.8,
    height: 38.62,
    viewBox: "0 0 45.8 38.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fdde42;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.6,15.5h0L4.1,7.6A4.82,4.82,0,0,1,8.6,4.7h8.2A6.42,6.42,0,0,1,23,0H39.4a6.38,6.38,0,0,1,6.4,6.36V27.5a6.38,6.38,0,0,1-6.36,6.4H38.5a6.47,6.47,0,0,1-7.9,4.5,6.39,6.39,0,0,1-4.5-4.5H19.7a6.47,6.47,0,0,1-7.9,4.5,6.39,6.39,0,0,1-4.5-4.5H6.4A6.38,6.38,0,0,1,0,27.54V17.8a6.4,6.4,0,0,1,.5-2.4h0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 2.8,
    width: 22.3,
    height: 18.5,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.3,11.6a.43.43,0,0,0-.4-.4H35.3a.32.32,0,0,1-.3-.3v-.8c0-.2,0-.4-.2-.5L31.4,6.7c-.2-.2-.5-.2-.6,0l-5.2,4.4a.72.72,0,0,0-.2.5v5.8a.43.43,0,0,0,.4.4H37a.43.43,0,0,0,.4-.4V11.7h0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.3,
    cy: 32.2,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 32.2,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,27.6a2.9,2.9,0,0,0,2.9,2.9h.9A6.47,6.47,0,0,1,15.3,26a6.39,6.39,0,0,1,4.5,4.5h6.4A6.47,6.47,0,0,1,34.1,26a6.39,6.39,0,0,1,4.5,4.5h.9a2.9,2.9,0,0,0,2.9-2.9h0V24.7H23.1a6.38,6.38,0,0,1-6.4-6.36V8.3H8.8a1.56,1.56,0,0,0-1.3.8L6.3,11.8h5.1a1.86,1.86,0,0,1,1.8,1.8v7a1.86,1.86,0,0,1-1.8,1.8H3.8v5.3h0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,18.8H9.5V15.3H4.6L3.9,17h0a3.78,3.78,0,0,0-.2,1v.9h0Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar2Black);
export default __webpack_public_path__ + "static/media/car2_black.2c01eb1c83ff6af3f524207a63cc9b37.svg";
export { ForwardRef as ReactComponent };